"use strict";

exports.__esModule = true;
exports["default"] = void 0;
var DIMENSIONS = {
  SIDE_BAR_WIDTH: 430,
  STORE_SIDE_BAR_WIDTH: 560,
  MOBILE_PADDING: 120,
  NO_PADDING: 0
};
var _default = DIMENSIONS;
exports["default"] = _default;